import { render, staticRenderFns } from "./NormalPage.vue?vue&type=template&id=d201d94a&scoped=true&"
import script from "./NormalPage.vue?vue&type=script&lang=js&"
export * from "./NormalPage.vue?vue&type=script&lang=js&"
import style0 from "./NormalPage.vue?vue&type=style&index=0&id=d201d94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d201d94a",
  null
  
)

export default component.exports